import React, { FC } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from 'gatsby-plugin-image'
import { renderRichText } from "gatsby-source-contentful/rich-text"

import { TextWithImageFragmentFragment } from "@graphqlTypes"

import { textOptions } from "../../Content.utils"

import {
  ContentTextWithImgDIV,
  ContentTextWithImgContentDIV,
} from "./ContentTextWithImg.styles"
import { ContentDIV } from "@components/Content/Content.styles"

const ContentTextWithImg: FC<TextWithImageFragmentFragment> = ({ textWithImgContent, textWithImgImage }) => (
  <ContentTextWithImgDIV className="ContentTextWithImg">
    <ContentTextWithImgContentDIV>
      <ContentDIV>
        {textWithImgContent && renderRichText(textWithImgContent, textOptions)}
      </ContentDIV>
    </ContentTextWithImgContentDIV>
    <div className="image-wrapper">
      {textWithImgImage && <GatsbyImage
        alt={textWithImgImage.title || ""}
        image={textWithImgImage?.imgixImage?.gatsbyImageData}
      />}
    </div>
  </ContentTextWithImgDIV>
)

export const TextWithImageFragment = graphql`
fragment TextWithImageFragment on ContentfulContentBlockTextWithImage {
  contentful_id
  textWithImgContent: content {
    raw
  }
  textWithImgImage: image {
    title
    imgixImage {
      gatsbyImageData(width: 300)
    }
  }
}
`

export default ContentTextWithImg